import { useTranslation } from "react-i18next";
import "./Contact.css";

const Contact = () => {
    const { t } = useTranslation();

    return (
        <main className="Contact border-shadow w-50 m-a">
            <h1>{t("contact.title")}</h1>
            <p>{t("contact.intro")}</p>
            <address>
                <a href="mailto:janijluostarinen@gmail.com"><i className="fa fa-envelope" aria-hidden="true"></i> janijluostarinen@gmail.com</a>
                <a href="tel:+358456413228"><i className="fa fa-phone" aria-hidden="true"></i> +358 45 641 3228</a>
                <span><i className="fa fa-map-pin" aria-hidden="true"></i> Lieksa, {t("contact.finland")}</span>
            </address>
            <div className="contactLinks">
                <a href="https://github.com/Janicxz" target="_blank" rel="noopener noreferrer" aria-label={t("contact.githubLabel")}>GitHub</a>
                <a href="https://www.linkedin.com/in/jani-luostarinen-9071a8316/" target="_blank" rel="noopener noreferrer" aria-label={t("contact.linkedinLabel")}>LinkedIn</a>
                <a href="https://www.credly.com/users/jani-luostarinen" target="_blank" rel="noopener noreferrer" aria-label={t("contact.credlyLabel")}>Credly</a>
            </div>
            <p>{t("experience.reference")}</p>
        </main>
    );
};
export default Contact;
